import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const BusinessLoginCard = () => {
  return (
    <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border-2 border-transparent hover:border-blue-500">
      {/* Card header with gradient */}
      <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-6 text-white">
        <div className="flex items-center justify-between mb-4">
          <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
            <Icon name="Briefcase" size={32} color="#FFFFFF" />
          </div>
          <div className="bg-blue-400/30 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium">
            Empresa
          </div>
        </div>
        <h2 className="text-2xl font-bold mb-2">Iniciar Sesión como Empresa</h2>
        <p className="text-blue-100">
          Gestiona tu negocio y atrae más clientes con promociones exclusivas
        </p>
      </div>

      {/* Card body */}
      <div className="p-6">
        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-blue-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Panel Empresarial Completo</h3>
              <p className="text-sm text-gray-600">
                Gestiona publicaciones, estadísticas y perfil de tu empresa
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-blue-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Código QR Personalizado</h3>
              <p className="text-sm text-gray-600">
                Genera y gestiona tu código QR único para atraer clientes
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-blue-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Análisis y Estadísticas</h3>
              <p className="text-sm text-gray-600">
                Monitorea visitas, escaneos y engagement de tus clientes
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-blue-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Publicaciones y Contenido</h3>
              <p className="text-sm text-gray-600">
                Crea y comparte contenido como en redes sociales
              </p>
            </div>
          </div>
        </div>

        {/* Login button */}
        <Link
          to="/business-login"
          className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors duration-200 shadow-md hover:shadow-lg group-hover:scale-105 transform"
        >
          <Icon name="LogIn" size={20} />
          <span>Iniciar Sesión como Empresa</span>
          <Icon name="ArrowRight" size={20} />
        </Link>

        {/* Additional info */}
        <div className="mt-4 text-center">
          <p className="text-xs text-gray-500">
            Al iniciar sesión, aceptas nuestros{' '}
            <Link to="/terms-and-conditions" className="text-blue-600 hover:underline">
              Términos y Condiciones
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessLoginCard;